import React, { useEffect, useState } from 'react';

const CARD_WIDTH = 320;
const CARD_MARGIN = 16;

function useTargetRect(selector, active) {
  const [rect, setRect] = useState(null);

  useEffect(() => {
    if (!active || !selector) {
      setRect(null);
      return undefined;
    }
    const update = () => {
      const el = document.querySelector(selector);
      setRect(el ? el.getBoundingClientRect() : null);
    };
    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);
    // Admin fields keep loading images / normalizing data after mount, which
    // can shift layout — poll briefly instead of trusting a single measurement.
    const poll = setInterval(update, 300);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, true);
      clearInterval(poll);
    };
  }, [selector, active]);

  return rect;
}

function cardPosition(rect) {
  if (!rect) {
    return {
      top: Math.max(24, window.innerHeight / 2 - 100),
      left: Math.max(16, window.innerWidth / 2 - CARD_WIDTH / 2),
    };
  }
  const spaceBelow = window.innerHeight - rect.bottom;
  const top = spaceBelow > 200
    ? rect.bottom + 16
    : Math.max(16, rect.top - 16 - 220);
  const left = Math.min(
    Math.max(rect.left, CARD_MARGIN),
    window.innerWidth - CARD_WIDTH - CARD_MARGIN
  );
  return { top, left };
}

export default function AdminTour({ steps, active, onClose }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (active) setIndex(0);
  }, [active]);

  const step = steps[index] || null;
  const rect = useTargetRect(step?.selector, active);

  if (!active || !step) return null;

  const isLast = index === steps.length - 1;
  const { top: cardTop, left: cardLeft } = cardPosition(rect);

  const highlightStyle = rect
    ? {
        top: rect.top - 8,
        left: rect.left - 8,
        width: rect.width + 16,
        height: rect.height + 16,
      }
    : { display: 'none' };

  return (
    <>
      <div className="fi-tour-scrim" />
      <div className="fi-tour-highlight" style={highlightStyle} />
      <div className="fi-tour-card" style={{ top: cardTop, left: cardLeft }}>
        <div className="fi-tour-card__step">Step {index + 1} of {steps.length}</div>
        <h3 className="fi-tour-card__title">{step.title}</h3>
        <p className="fi-tour-card__desc">{step.description}</p>
        <div className="fi-tour-card__actions">
          <button type="button" className="fi-tour-btn fi-tour-btn--skip" onClick={onClose}>
            Skip
          </button>
          <div className="fi-tour-card__nav">
            {index > 0 ? (
              <button
                type="button"
                className="fi-tour-btn fi-tour-btn--back"
                onClick={() => setIndex((i) => Math.max(0, i - 1))}
              >
                Back
              </button>
            ) : null}
            <button
              type="button"
              className="fi-tour-btn fi-tour-btn--next"
              onClick={() => (isLast ? onClose() : setIndex((i) => i + 1))}
            >
              {isLast ? 'Finish' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
